import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

import general from './general.js';

const applicationParts = [general];

export const activeLanguages = ['cz', 'en'];

const messages = activeLanguages.reduce(
    (languages, language) => ({
        ...languages,
        [language]: applicationParts.reduce(
            (parts, part) => ({
                ...parts,
                ...part[language],
            }),
            {}
        ),
    }),
    {}
);

const i18n = new VueI18n({
    locale: 'cz',
    messages,
});

export const t = (path, placeholders) => {
    const _messages = i18n.messages[i18n.locale];
    const _path = path.split('.');
    let text = _path.reduce((acc, value) => acc[value], _messages);

    for (let key in placeholders) {
        const placeholder = placeholders[key];
        const regexp = new RegExp(`{${key}}`, 'gi');
        text = text.replace(regexp, placeholder);
    }

    return text;
};

export default i18n;
